// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import utils from 'inomph-common'
import VueMeta from 'vue-meta'
import Snackbar from 'node-snackbar'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import DataTable from 'vue-materialize-datatable'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
Vue.use(VueMeta, {
  keyName: 'meta'
})
// Vue.use(VeeValidate)
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
})

Vue.use(DataTable)

Vue.config.productionTip = false
// require('./assets/app.css')
require('materialize-css')
require('materialize-css/dist/css/materialize.min.css')
require('jquery')
require('jquery-ui')
// require('materialize-stepper')
// require('materialize-stepper/materialize-stepper.min.css')
require('node-snackbar/dist/snackbar.min.css')

Snackbar.error = function (errorMessage) {
  this.show({
    text: errorMessage,
    actionText: 'okay',
    pos: 'bottom-right',
    showAction: true,
    textColor: '#FFF',
    actionTextColor: '#d3d3d3',
    backgroundColor: '#B03236',
    customClass: 'fast',
    duration: 5000
  })
}

Snackbar.success = function (successMessage) {
  this.show({
    text: successMessage,
    pos: 'bottom-right',
    showAction: false,
    textColor: '#FFF',
    backgroundColor: '#039403',
    customClass: 'fast',
    duration: 2000
  })
}

Object.defineProperty(Vue.prototype, '$utils', {value: utils})
Object.defineProperty(Vue.prototype, '$snackbar', {value: Snackbar})
Object.defineProperty(Vue.prototype, '$config', { value: process.env })
Object.defineProperty(Vue.prototype, '$http', { value: axios })
// eslint-disable-next-line no-undef
Object.defineProperty(Vue.prototype, '$M', {value: M})

const root = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store
})

store.commit('modal/setVue', Vue)
store.commit('modal/setParent', root)



// WEBPACK FOOTER //
// ./src/main.js